import {Model} from "../models/Model";
import {ModelKey} from "../models/ModelKey";
import {ControllerEvent} from "../event-buses/ControllerEvent";
import {inject, InjectionToken} from "@angular/core";
import {DOCUMENT} from "@angular/common";

export const IT_WINDOW = new InjectionToken<Window>('IT_WINDOW', {
  factory: () => {
    const document = inject(DOCUMENT);
    return document.defaultView!;
  }
});

export const IT_CONTROLLER_OVERRIDES = new InjectionToken<any>('IT_CONTROLLER_OVERRIDES');

export interface IController {

  addModel<T extends Model>(modelKey: ModelKey<T>, model: T): void;
  getModel<T extends Model>(modelKey: ModelKey<T>): T;
  emit(event: ControllerEvent): void;
  handle(eventName: string, eventData: any): any;
}
